import { type Context, createContext, useContext } from 'react';

export type Apps = 'home' | 'goals' | 'teams' | 'focus' | 'projects' | 'teams-isolated';
export type GoalPanelAnalyticsSource = `${Apps}-goal-panel`;

export const AppContext: Context<{ app: Apps }> = createContext({
	app: 'home' as Apps,
});

export const useTownsquareApp = (): Apps => {
	const ctx = useContext(AppContext);

	return ctx.app;
};

export const useIsTownsquare = (): boolean => {
	return useTownsquareApp() !== 'focus';
};

export const useIsStandAloneApp = (): boolean => {
	const appName = useTownsquareApp();
	return appName === 'goals' || appName === 'projects';
};
